export default "__VITE_ASSET__DcqsFsNb__"